<template>
  <section :style="styles" :class="classNames">
    <header ref="header">
      <FilterForm />
    </header>
    <main>
      <div v-if="error" class="error">
        {{ error }}
      </div>
      <div v-else-if="loading" class="loading">
        Lade...
      </div>
      <SeasonList :seasons="productionsByLocationBySeason" v-slot="{ season }">
        <LocationList
          :locations="season.locations"
          :params="{ highlight: true }"
          v-slot="{ location }"
        >
          <ProductionList :productions="location.productions" />
        </LocationList>
      </SeasonList>
      <SvgIcon icon="brut" :unwrap="false" />
    </main>
    <aside>
      <LocationMap v-if="!loading" :locations="locations" />
    </aside>
    <router-view />
  </section>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

import FilterForm from '@/components/FilterForm'
import LocationList from '@/components/LocationList'
import LocationMap from '@/components/LocationMap'
import ProductionList from '@/components/ProductionList'
import SeasonList from '@/components/SeasonList'
import SvgIcon from '@/components/SvgIcon'

export default {
  name: 'Main',
  components: {
    FilterForm,
    LocationList,
    LocationMap,
    ProductionList,
    SeasonList,
    SvgIcon
  },
  data() {
    return {
      headerHeight: 0
    }
  },
  computed: {
    ...mapState(['loading', 'error', 'mapVisible']),
    ...mapGetters(['locations', 'productionsByLocationBySeason']),
    styles() {
      return {
        '--header-height': `${this.headerHeight}px`
      }
    },
    classNames() {
      return {
        'is-map-visible': this.mapVisible
      }
    }
  },
  methods: {
    handleResize() {
      this.measureHeaderHeight()
    },
    measureHeaderHeight() {
      this.headerHeight = this.$refs.header.offsetHeight
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
    this.$nextTick(() => {
      this.handleResize()
      setTimeout(this.handleResize, 1000)
    })
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleResize)
  },
  watch: {
    headerHeight(val) {
      document.documentElement.style.setProperty('--header-height', `${val}px`)
    }
  }
}
</script>

<style scoped>
section {
  --header-height: 0;
  width: 100%;
}
header {
  position: sticky;
  top: 0;
  background: var(--color-background);
  z-index: var(--zindex-filter);
}
main {
  position: relative;
  width: 100%;
  min-height: calc(100vh - var(--header-height) - var(--page-padding));
  z-index: var(--zindex-content);
  display: flex;
  flex-direction: column;
  transition: 500ms opacity;
}
aside {
  position: fixed;
  top: calc(var(--header-height));
  right: var(--page-padding);
  width: calc(100% - calc(2 * var(--page-padding)));
  height: calc(100vh - var(--header-height) - var(--page-padding));
  background-color: #eee;
  overflow: hidden;
  display: flex;
  user-select: none;
  z-index: var(--zindex-map);
  transition: 500ms opacity, 500ms transform;
  pointer-events: none;
  transform: translate3d(0, calc(101% + var(--page-padding)), 0);
}
.is-map-visible {
  main {
    opacity: 0;
    pointer-events: none;
  }
  aside {
    opacity: 1;
    pointer-events: auto;
    transform: none;
  }
}
/deep/ .icon-brut {
  @mixin brut-list-icon;
}
@mixin breakpoint-medium {
  main,
  aside {
    opacity: 1;
    pointer-events: auto;
    transform: none;
  }
  main {
    width: var(--content-width-aside);
    padding-top: 1px;
    padding-right: var(--page-padding);
  }
  aside {
    width: var(--content-width-main);
  }
}
@media only print {
  section {
    display: block;
    flex-direction: column;
  }
  header {
    order: -2;
    position: static;
  }
  main {
    display: block;
    padding-top: 1em;
    max-width: 38em;
    margin-bottom: 4em;
    page-break-before: always;
    page-break-after: always;
  }
  aside {
    order: -1;
    position: static;
    width: 100%;
    height: 24cm;
    height: 90vh;
    background-color: transparent;
    opacity: 1;
    pointer-events: auto;
    transform: none;
    page-break-before: always;
    page-break-after: always;
  }
  form {
    padding-top: var(--page-padding);
  }
  /deep/ .icon-brut {
    display: none;
  }
  /deep/ .gmnoprint {
    display: none;
  }
  /deep/ .vue-map [style*='background-color'] {
    background-color: transparent !important;
  }
}
</style>
